var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDownSLightFilled = function SvgIconDownSLightFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_down_s_light_filled_svg__a)",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.1 30.5 6.8-11.6c.5-.8-.1-1.8-1-1.8H17.3c-.9 0-1.5 1-1 1.8l6.8 11.6c.4.8 1.6.8 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.358 19.468C14.396 17.905 15.58 16 17.3 16h13.6c1.719 0 2.904 1.905 1.942 3.468L26.065 31.03c-.817 1.56-3.113 1.56-3.93 0l-6.777-11.562Zm1.86-1.186c0 .002 0 .012.015.035l.016.027 6.8 11.6.03.053a.091.091 0 0 0 .043 0l.029-.053 6.8-11.6.016-.027c.015-.023.014-.033.014-.035a.075.075 0 0 0-.011-.036.104.104 0 0 0-.035-.037.063.063 0 0 0-.035-.009H17.3a.063.063 0 0 0-.035.009.104.104 0 0 0-.035.037.075.075 0 0 0-.011.035Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_down_s_light_filled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15 16)",
    d: "M0 0h18.2v16.2H0z"
  })))));
};
export default SvgIconDownSLightFilled;